import React, { useEffect } from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Redirect,
  Switch,
  Route,
} from 'react-router-dom';
import Dashboard from './pages/DashboardPage';
import Map from './pages/Map';
// import testTable from './pages/DashboardPage/testTable';
import RequestPasswordReset from './pages/RequestPasswordReset';
import ChangePassword from './pages/ResetPassword';
import Login from './pages/Login';
const Cookies = require('js-cookie');

function App() {
  let authObj = Cookies.get('authObj');
  let autheticated = false;
  if (authObj) {
    autheticated = JSON.parse(authObj);
    autheticated = autheticated['success'];
  }
  return (
    <Router>
      <div>
        <Switch>
          <Route exact path='/'>
            <Redirect to='/login' />
          </Route>
          <Route exact path='/login' component={Login} />
          <Route path={'/changePassword/:token'} component={ChangePassword} />
          <Route
            exact
            path='/reset_password'
            component={RequestPasswordReset}
          />
          <Route path='/dashboard' component={Dashboard} />
          {/* <Route path='/testPage' component={testTable} /> */}

          <Route
            render={() => {
              if (autheticated) {
                return <Redirect to='/dashboard' />;
              } else {
                return <Redirect to='/login' />;
              }
            }}
          />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
